export interface IDueInventoryItemConfig {
    inventoryItemId: number;
    shortName: string;
    name: string;
    lifetimeYears: number;
}

export function readDueInventoryItemConfig(value: any): IDueInventoryItemConfig | null {
    let config = value;
    if (typeof config === "string") {
        if (config.trim() === "") {
            return null;
        }
        try {
            config = JSON.parse(config);
        } catch (e) {
            return null;
        }
    }
    if (!config || typeof config !== "object") {
        return null;
    }
    const inventoryItemId = parseInt(config.inventoryItemId, 10);
    const lifetimeYears = parseInt(config.lifetimeYears, 10);
    if (!Number.isFinite(inventoryItemId) || !Number.isFinite(lifetimeYears) || lifetimeYears < 0) {
        return null;
    }
    return {
        inventoryItemId,
        shortName: String(config.shortName || ""),
        name: String(config.name || config.shortName || ""),
        lifetimeYears,
    };
}
